import { mapState } from 'vuex';
import { handleLocalStorage } from '@/assets/js/utils.js';
export default {
  props: {
    info: Object,
    showClose: {
      type: Boolean,
      default: true
    },
    height: {
      type: String
    },
    width: {
      type: String,
      default: '640px'
    },
    notClose: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      State: state => state
    })
  },
  data() {
    return {
      checkRemindMe: false,
      allowClose: true
    };
  },
  created() {
    this.checkRemindMe = localStorage.getItem(`aiPolicyNotShown_${handleLocalStorage('get', 'memberId') || 'PL_' + new Date().getTime()}`) == 'true';
  },
  methods: {
    handleCheckboxChange() {
      this.$emit('notRemind', this.checkRemindMe);
    },
    openDialog() {
      this.$emit('open');
    },
    closeDialog() {
      this.$emit('close');
    },
    gotIt() {
      this.info.show = false;
    },
    cancel() {
      this.info.show = false;
      this.$emit('cancel', 'notAllowed');
    },
    save() {
      this.$emit('save');
      if (!this.notClose && this.allowClose) this.info.show = false;
    }
  }
};